import * as React from 'react';
import { styled } from '@mui/material';
import { usePaymentContext } from '../context';

const IFrame = styled('iframe')(({ theme }) => ({
    width: '100%',
    border: 'none',
    height: '580px',
    [theme.breakpoints.up('sm')]: {
        height: '500px',
    },
    [theme.breakpoints.up('md')]: {
        height: '470px',
    },
}));

export default function CapturePaymentData() {
    const paymentContext = usePaymentContext();

    return (<IFrame title="Opayo Payment" src={paymentContext.transactionUrl} />)
}
